import { City, ErrorPayLoad, GetHtmlPreInvoicePayload, ILine, Line, Package, ProposedNumber, SelectByProductIdPayLoad, SelectCandidatePayLoad } from "../interfaces/purchase";
import { Types } from "../types";
import {
    GetApplicationContractTypeError,
    GetApplicationContractTypeRequest,
    GetApplicationContractTypeSuccess,
    GetFreeProposedNumbersError, GetFreeProposedNumbersRequest, GetFreeProposedNumbersSuccess, GetHtmlPreInvoiceToCustomerError, GetHtmlPreInvoiceToCustomerRequest, GetHtmlPreInvoiceToCustomerSuccess, GetProductNumbersCountError,
    GetProductNumbersCountRequest, GetProductNumbersCountSuccess, SearchFreeProposeNumberError, SearchFreeProposeNumberRequest, SearchFreeProposeNumberSuccess, SelectCandidateFaxError, SelectCandidateFaxRequest,
    SelectCandidateFaxSuccess, SelectCandidateIVRError, SelectCandidateIVRRequest, SelectCandidateIVRSuccess,
    SelectCandidateSecretaryError, SelectCandidateSecretaryRequest, SelectCandidateSecretarySuccess, SetResetPurchaseProps, generateHtmlPreInvoiceToNewlyCustomerRegisteredError, generateHtmlPreInvoiceToNewlyCustomerRegisteredRequest, generateHtmlPreInvoiceToNewlyCustomerRegisteredSuccess, getCitiesError, getCitiesRequest, getCitiesSuccess, getIsFreeProductError, getIsFreeProductRequest, getIsFreeProductSuccess, getPrepareForGatewayError, getPrepareForGatewayRequest, getPrepareForGatewaySuccess,
    getProposedNumbersError,
    getProposedNumbersRequest,
    getProposedNumbersSuccess,
    getPurchaseInfoError,
    getPurchaseInfoRequest,
    getPurchaseInfoSuccess,
    postPurchaseBuyError, postPurchaseBuyRequest, postPurchaseBuySuccess, postTryReserveRequestedLinesError, postTryReserveRequestedLinesRequest, postTryReserveRequestedLinesSuccess, searchProposedNumbersError, searchProposedNumbersRequest, searchProposedNumbersSuccess
} from "../types/Purchase/actionsType";
import { GetPrepareForGatewayPayload, PostPurchaseBuyPayload, SearchFreeProposedNumbersPayload, generateHtmlPreInvoiceToNewlyCustomerRegistered, getPurchaseInfoPayload, proposedNumbersPayload, searchProposedNumbersPayload } from "../types/Purchase/apiRequestTypes";




export const getFreeProposedNumbersRequestAction = (payload: SelectCandidatePayLoad): GetFreeProposedNumbersRequest => ({
    type: Types.SELECT_PACKAGE_REQUEST,
    payload
})

export const getFreeProposedNumbersSuccessAction = (response: ILine[]): GetFreeProposedNumbersSuccess => ({
    type: Types.SELECT_PACKAGE_SUCCESS,
    response
})

export const getFreeProposedNumbersErrorAction = (payload: ErrorPayLoad): GetFreeProposedNumbersError => ({
    type: Types.SELECT_PACKAGE_ERROR,
    payload
})



export const getCandidateIVRRequestAction = (payload: SelectByProductIdPayLoad): SelectCandidateIVRRequest => ({
    type: Types.GET_CANDIDATE_IVR_PRODUCT_REQUEST,
    payload
})

export const getCandidateIVRSuccessAction = (response: Package | null): SelectCandidateIVRSuccess => ({
    type: Types.GET_CANDIDATE_IVR_PRODUCT_SUCCESS,
    response
})


export const getCandidateIVRErrorAction = (payload: ErrorPayLoad): SelectCandidateIVRError => ({
    type: Types.GET_CANDIDATE_IVR_PRODUCT_ERROR,
    payload

})



export const getCandidateSecretaryRequestAction = (payload: SelectByProductIdPayLoad): SelectCandidateSecretaryRequest => ({
    type: Types.GET_CANDIDATE_SECRETARY_PRODUCT_REQUEST,
    payload
})
export const getCandidateSecretarySuccessAction = (response: Package | null): SelectCandidateSecretarySuccess => ({
    type: Types.GET_CANDIDATE_SECRETARY_PRODUCT_SUCCESS,
    response
})
export const getCandidateSecretaryErrorAction = (payload: ErrorPayLoad): SelectCandidateSecretaryError => ({
    type: Types.GET_CANDIDATE_SECRETARY_PRODUCT_ERROR,
    payload

})

export const getCandidateFaxRequestAction = (payload: SelectByProductIdPayLoad): SelectCandidateFaxRequest => ({
    type: Types.GET_CANDIDATE_FAX_PRODUCT_REQUEST,
    payload
})

export const getCandidateFaxSuccessAction = (response: Package | null): SelectCandidateFaxSuccess => ({
    type: Types.GET_CANDIDATE_FAX_PRODUCT_SUCCESS,
    response
})
export const getCandidateFaxErrorAction = (payload: ErrorPayLoad): SelectCandidateFaxError => ({
    type: Types.GET_CANDIDATE_FAX_PRODUCT_ERROR,
    payload
})


export const getProductNumbersCountRequestAction = (payload: SelectByProductIdPayLoad): GetProductNumbersCountRequest => ({
    type: Types.GET_PRODUCT_NUMBERS_COUNT_REQUEST,
    payload
})

export const getProductNumbersCountSuccessAction = (response: number | null): GetProductNumbersCountSuccess => ({
    type: Types.GET_PRODUCT_NUMBERS_COUNT_SUCCESS,
    response
})

export const getProductNumbersCountErrorAction = (payload: ErrorPayLoad): GetProductNumbersCountError => ({
    type: Types.GET_PRODUCT_NUMBERS_COUNT_ERROR,
    payload
})


export const getApplicationContractTypeRequestAction = (payload: SelectByProductIdPayLoad): GetApplicationContractTypeRequest => ({
    type: Types.GET_APPLICATION_CONTRACT_TYPE_REQUEST,
    payload
})

export const getApplicationContractTypeSuccessAction = (response: any | null): GetApplicationContractTypeSuccess => ({
    type: Types.GET_APPLICATION_CONTRACT_TYPE_SUCCESS,
    response
})

export const getApplicationContractTypeErrorAction = (payload: ErrorPayLoad): GetApplicationContractTypeError => ({
    type: Types.GET_APPLICATION_CONTRACT_TYPE_ERROR,
    payload
})



export const GetHtmlPreInvoiceToCustomerRequestAction = (payload: GetHtmlPreInvoicePayload): GetHtmlPreInvoiceToCustomerRequest => ({
    type: Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_REQUEST,
    payload
})

export const GetHtmlPreInvoiceToCustomerSuccessAction = (response: any | null): GetHtmlPreInvoiceToCustomerSuccess => ({
    type: Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_SUCCESS,
    response
})

export const GetHtmlPreInvoiceToCustomerErrorAction = (payload: ErrorPayLoad): GetHtmlPreInvoiceToCustomerError => ({
    type: Types.GEN_HTML_PRE_INVOICE_TO_CUSTOMER_ERROR,
    payload
})


export const SearchFreeProposeNumberRequestAction = (payload: SearchFreeProposedNumbersPayload): SearchFreeProposeNumberRequest => ({
    type: Types.SEARCH_FREE_PROPOSE_NUMBER_REQUEST,
    payload
})

export const SearchFreeProposeNumberSuccessAction = (response: Line[] | null): SearchFreeProposeNumberSuccess => ({
    type: Types.SEARCH_FREE_PROPOSE_NUMBER_SUCCESS,
    response
})

export const SearchFreeProposeNumberErrorAction = (payload: ErrorPayLoad): SearchFreeProposeNumberError => ({
    type: Types.SEARCH_FREE_PROPOSE_NUMBER_ERROR,
    payload
})


export const getPrepareForGatewayRequestAction = (payload: GetPrepareForGatewayPayload): getPrepareForGatewayRequest => ({
    type: Types.GET_PREPARE_FOR_GATEWAY_REQUEST,
    payload
})

export const getPrepareForGatewaySuccessAction = (response: any): getPrepareForGatewaySuccess => ({
    type: Types.GET_PREPARE_FOR_GATEWAY_SUCCESS,
    response
})

export const getPrepareForGatewayErrorAction = (payload: ErrorPayLoad): getPrepareForGatewayError => ({
    type: Types.GET_PREPARE_FOR_GATEWAY_ERROR,
    payload
})


export const postTryReserveRequestedLinesRequestAction = (payload: string): postTryReserveRequestedLinesRequest => ({
    type: Types.POST_TRY_RESERVE_LINE_REQUEST,
    payload
})

export const postTryReserveRequestedLinesSuccessAction = (response: any): postTryReserveRequestedLinesSuccess => ({
    type: Types.POST_TRY_RESERVE_LINE_SUCCESS,
    response
})

export const postTryReserveRequestedLinesErrorAction = (payload: ErrorPayLoad): postTryReserveRequestedLinesError => ({
    type: Types.POST_TRY_RESERVE_LINE_ERROR,
    payload
})



export const postPurchaseBuyRequestAction = (payload: PostPurchaseBuyPayload): postPurchaseBuyRequest => ({
    type: Types.POST_PURCHASE_BUY_REQUEST,
    payload
})

export const postPurchaseBuySuccessAction = (response: PostPurchaseBuyPayload): postPurchaseBuySuccess => ({
    type: Types.POST_PURCHASE_BUY_SUCCESS,
    response
})

export const postPurchaseBuyErrorAction = (payload: ErrorPayLoad): postPurchaseBuyError => ({
    type: Types.POST_PURCHASE_BUY_ERROR,
    payload
})



export const getPurchaseInfoRequestAction = (payload: getPurchaseInfoPayload): getPurchaseInfoRequest => ({
    type: Types.GET_PURCHASE_INFO_REQUEST,
    payload
})

export const getPurchaseInfoSuccessAction = (response: getPurchaseInfoPayload): getPurchaseInfoSuccess => ({
    type: Types.GET_PURCHASE_INFO_SUCCESS,
    response
})

export const getPurchaseInfoErrorAction = (payload: ErrorPayLoad): getPurchaseInfoError => ({
    type: Types.GET_PURCHASE_INFO_ERROR,
    payload
})


export const getCitiesRequestAction = (): getCitiesRequest => ({
    type: Types.GET_CITIES_REQUEST,
})

export const getCitiesSuccessAction = (response: City[] | null): getCitiesSuccess => ({
    type: Types.GET_CITIES_SUCCESS,
    response
})

export const getCitiesErrorAction = (payload: ErrorPayLoad): getCitiesError => ({
    type: Types.GET_CITIES_ERROR,
    payload
})


export const getProposedNumbersRequestAction = (payload: proposedNumbersPayload): getProposedNumbersRequest => ({
    type: Types.GET_PROPOSED_NUMBERS_REQUEST,
    payload
})

export const getProposedNumbersSuccessAction = (response: any): getProposedNumbersSuccess => ({
    type: Types.GET_PROPOSED_NUMBERS_SUCCESS,
    response
})

export const getProposedNumbersErrorAction = (payload: ErrorPayLoad): getProposedNumbersError => ({
    type: Types.GET_PROPOSED_NUMBERS_ERROR,
    payload
})


export const searchProposedNumbersRequestAction = (payload: proposedNumbersPayload): searchProposedNumbersRequest => ({
    type: Types.SEARCH_PROPOSED_NUMBERS_REQUEST,
    payload
})

export const searchProposedNumbersSuccessAction = (response: ProposedNumber[] | null): searchProposedNumbersSuccess => ({
    type: Types.SEARCH_PROPOSED_NUMBERS_SUCCESS,
    response
})

export const searchProposedNumbersErrorAction = (payload: ErrorPayLoad): searchProposedNumbersError => ({
    type: Types.SEARCH_PROPOSED_NUMBERS_ERROR,
    payload
})



export const getIsFreeProductRequestAction = (payload: string): getIsFreeProductRequest => ({
    type: Types.GET_IS_FREE_PRODUCT_REQUEST,
    payload
})

export const getIsFreeProductSuccessAction = (response: boolean): getIsFreeProductSuccess => ({
    type: Types.GET_IS_FREE_PRODUCT_SUCCESS,
    response
})

export const getIsFreeProductErrorAction = (payload: ErrorPayLoad): getIsFreeProductError => ({
    type: Types.GET_IS_FREE_PRODUCT_ERROR,
    payload
})


export const generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestAction = (payload: generateHtmlPreInvoiceToNewlyCustomerRegistered):
    generateHtmlPreInvoiceToNewlyCustomerRegisteredRequest => ({
        type: Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_REQUEST,
        payload
    })

export const generateHtmlPreInvoiceToNewlyCustomerRegisteredSuccessAction = (response: any): generateHtmlPreInvoiceToNewlyCustomerRegisteredSuccess => ({
    type: Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_SUCCESS,
    response
})

export const generateHtmlPreInvoiceToNewlyCustomerRegisteredErrorAction = (payload: ErrorPayLoad): generateHtmlPreInvoiceToNewlyCustomerRegisteredError => ({
    type: Types.GEN_HTML_PRE_INVOICE_NEWLY_REGISTER_CUSTOMER_ERROR,
    payload
})



export const resetPurchasePropsAction = (): SetResetPurchaseProps => ({
    type: Types.SET_RESET_PURCHASE_PROPS,
})


export const resetInvoiceAction = () => ({
    type: Types.RESET_INVOICE,
})
